// ─── Crédit de l'or de duel — écriture ciblée Supabase (Beta v1) ──────────────
// Le reward gold LeagueDuel ne doit PAS partir de player.match_gold côté state
// local (potentiellement stale → régression de match_gold en DB).
//
// Ici on relit match_gold depuis Supabase juste avant le crédit, on additionne,
// et on PATCH uniquement { match_gold }. Aucun passage par savePlayer (qui
// réécrit tout le bloc joueur avec un snapshot local).
//
// TODO RPC : remplacer par `credit_duel_gold(player_name, amount)` atomique
// (read-modify-write en une transaction) avant release publique — évite le
// double-crédit concurrent entre deux clients.

import { sb } from "../../../lib/supabase";

/**
 * Crédite `amount` d'or de duel sur match_gold, en repartant de la valeur DB.
 *
 * Retourne le nouveau match_gold (number) en cas de succès, ou `null` si la
 * lecture OU l'écriture Supabase a échoué. En cas de null, l'appelant NE DOIT
 * PAS écrire une valeur calculée depuis le state local.
 */
export async function creditDuelGold(
  playerName: string,
  amount: number
): Promise<number | null> {
  const enc = encodeURIComponent(playerName);

  // 1. Relire la valeur DB fraîche (source de vérité).
  const rows = await sb.get(`players?name=eq.${enc}&select=match_gold&limit=1`);
  if (!rows[0]) {
    // sb.get renvoie [] sur erreur HTTP/réseau OU joueur introuvable : dans les
    // deux cas on refuse d'écrire (pas de base fiable).
    console.error(
      `[DuelGold] lecture match_gold échouée pour "${playerName}" — crédit annulé, state local inchangé`
    );
    return null;
  }

  const dbMatchGold = typeof rows[0].match_gold === "number" ? rows[0].match_gold : 0;
  const nextMatchGold = dbMatchGold + amount;

  // 2. PATCH ciblé : uniquement match_gold.
  const ok = await sb.patch("players", `name=eq.${enc}`, { match_gold: nextMatchGold });
  if (!ok) {
    console.error(
      `[DuelGold] PATCH match_gold échoué pour "${playerName}" (db=${dbMatchGold}, +${amount}) — crédit annulé`
    );
    return null;
  }

  console.log("[DuelGoldReward] creditDuelGold", {
    player: playerName,
    amount,
    dbBefore: dbMatchGold,
    dbAfter: nextMatchGold,
    timestamp: new Date().toISOString(),
  });
  return nextMatchGold;
}
